/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Progress Up Icon component.
 */
export const ProgressUpIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M29.0885 23.8624L28.5775 11.3929L16.3762 11.1501' stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M9.25945 30.966L27.9565 12.2861' stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default ProgressUpIcon;
